export const cilExpandLeft = ["24 24","<path d='M21.75 0.75h1.5v22.5h-1.5v-22.5z'></path><path d='M0.75 23.25h6v-22.5h-6zM2.25 2.25h3v19.5h-3z'></path><path d='M9.786 11.996l7.842 7.504h1.871v-15h-1.775zM18 17.779l-6.036-5.776 6.036-5.7z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-expand-left.js
// module id = null
// module chunks = 